const breakpoints = {
  m: "37.5em",
  l: "56.25em",
  xl: "75em"
};
const listeners = /* @__PURE__ */ new Set();
let initialized = false;
let mediaRules;
const createRules = () => {
  if (initialized || typeof window === "undefined")
    return;
  mediaRules = {
    md: window.matchMedia(`(min-width: ${breakpoints.m})`),
    lg: window.matchMedia(`(min-width: ${breakpoints.l})`),
    xl: window.matchMedia(`(min-width: ${breakpoints.xl})`),
    portrait: window.matchMedia("(orientation: portrait)")
  };
  initialized = true;
};
let breakpoint = "sm";
let orientation = "portrait";
function handleBreakpointChange() {
  if (!initialized)
    return;
  let newBreakpoint = "sm";
  let newOrientation = "portrait";
  if (mediaRules.xl.matches)
    newBreakpoint = "xl";
  else if (mediaRules.lg.matches)
    newBreakpoint = "lg";
  else if (mediaRules.md.matches)
    newBreakpoint = "md";
  newOrientation = mediaRules.portrait.matches ? "portrait" : "landscape";
  if (newBreakpoint !== breakpoint || newOrientation !== orientation) {
    breakpoint = newBreakpoint;
    orientation = newOrientation;
    listeners.forEach((listener) => listener(breakpoint, orientation));
  }
}
const addBreakpointListeners = () => {
  if (!initialized)
    initializeRules();
  Object.values(mediaRules).forEach(
    (rule) => typeof mediaRules.md.addEventListener === "function" ? rule.addEventListener("change", handleBreakpointChange) : rule.addListener(handleBreakpointChange)
    // Safari v13 Fallback
  );
};
const removeBreakpointListeners = () => {
  Object.values(mediaRules).forEach(
    (rule) => typeof mediaRules.md.removeEventListener === "function" ? rule.removeEventListener("change", handleBreakpointChange) : rule.removeListener(handleBreakpointChange)
    // Safari v13 Fallback
  );
};
function addBreakpointListener(listener) {
  if (listeners.has(listener))
    return;
  if (listeners.size === 0) {
    addBreakpointListeners();
  }
  listeners.add(listener);
}
function removeBreakpointListener(listener) {
  if (!listeners.has(listener))
    return;
  listeners.delete(listener);
  if (listeners.size === 0)
    removeBreakpointListeners();
}
function initializeRules() {
  if (!initialized) {
    createRules();
    handleBreakpointChange();
  }
}
function getCurrentBreakpoint() {
  if (!initialized)
    initializeRules();
  return breakpoint;
}
function getCurrentOrientation() {
  if (!initialized)
    initializeRules();
  return orientation;
}
export {
  addBreakpointListener,
  breakpoints,
  getCurrentBreakpoint,
  getCurrentOrientation,
  removeBreakpointListener
};
